import { render, staticRenderFns } from "./EmployeeCarousel.vue?vue&type=template&id=06a699a0&scoped=true"
import script from "./EmployeeCarousel.vue?vue&type=script&lang=ts"
export * from "./EmployeeCarousel.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeCarousel.vue?vue&type=style&index=0&id=06a699a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a699a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
